import { RadioGroupItem } from '@/shared/components/ui/radio-group'
import { cn } from '@shared/lib/utils'

interface RadioOptionProps {
  value: string
  label: string
  isSelected: boolean
  className?: string
}

export function RadioOption({ value, label, isSelected, className }: RadioOptionProps) {
  return (
    <label
      className={cn(
        'min-h-[50px] flex cursor-pointer items-center gap-3 rounded-[16px] border bg-white px-4 py-3 text-sm text-client-neutral-950 transition-colors',
        isSelected
          ? 'border-client-primary shadow-[0_8px_16px_rgba(55,81,255,0.12)]'
          : 'border-client-neutral-50',
        className
      )}
    >
      <RadioGroupItem
        value={value}
        className="h-5 w-5 border-client-primary text-client-primary"
        aria-label={label}
      />
      {label}
    </label>
  )
}
